import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import GetStarted from "@/pages/GetStarted";
import Merch from "@/pages/Merch";
import Journey from "@/pages/Journey";

const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    const lenis = window.__lenis;
    if (location.hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (!el) return;
        if (lenis) {
          lenis.scrollTo(el, { offset: -80, duration: 1.6 });
        } else {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 350);
      return () => clearTimeout(timer);
    }
    lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15 });
    window.__lenis = lenis;
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App bg-bone text-ink">
      <BrowserRouter>
        <Toaster richColors position="top-center" />
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/merch" element={<Merch />} />
          <Route path="/journey" element={<Journey />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
